/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Toast_DismissInputs */

const en_auth_toast_dismiss = /** @type {(inputs: Auth_Toast_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const pl_auth_toast_dismiss = /** @type {(inputs: Auth_Toast_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Auth_Toast_DismissInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_toast_dismiss = /** @type {((inputs?: Auth_Toast_DismissInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Toast_DismissInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_toast_dismiss(inputs)
	return en_auth_toast_dismiss(inputs)
});